import type { BaseClient } from '../../http/BaseClient.js';
import type {
  CreateScheduledTaskRequest,
  ListScheduledTasksQuery,
  ListScheduledTasksResponse,
  ScheduledTask,
  SimpleAgentResponse,
} from './types.js';

const BASE_PATH = '/api/agentengine/v1/agent/scheduled-tasks';

export class ScheduledTasksClient {
  constructor(private readonly http: BaseClient) {}

  list(query: ListScheduledTasksQuery): Promise<ListScheduledTasksResponse> {
    return this.http.get<ListScheduledTasksResponse>(BASE_PATH, { query });
  }

  create(body: CreateScheduledTaskRequest): Promise<ScheduledTask> {
    return this.http.post<ScheduledTask>(BASE_PATH, { body });
  }

  delete(taskId: string, orgId: string): Promise<SimpleAgentResponse> {
    return this.http.delete<SimpleAgentResponse>(`${BASE_PATH}/${taskId}`, {
      query: { org_id: orgId },
    });
  }
}
